import React from "react";
import { Instagram, Twitter, Facebook, Mail } from "lucide-react";

const columns = [
  {
    title: "Company",
    links: ["About", "Our story", "Press", "Careers"],
  },
  {
    title: "For vendors",
    links: ["Become a vendor", "Vendor guide", "Payouts", "Support"],
  },
  {
    title: "Support",
    links: ["Help centre", "Contact us", "Cancellations", "Order tracking"],
  },
  {
    title: "Legal",
    links: ["Terms of service", "Privacy policy", "Cookies", "Acceptable use"],
  },
];

export const Footer = () => {
  return (
    <footer
      data-testid="liea-footer"
      style={{
        background: "var(--liea-forest)",
        color: "var(--liea-cream-soft)",
      }}
    >
      <div className="liea-container py-20 md:py-24">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-4">
            <div
              className="liea-mark text-[34px] md:text-[40px]"
              style={{ color: "var(--liea-cream-soft)" }}
            >
              LIÉA<span className="dot">.</span>
            </div>
            <p
              className="mt-4 max-w-sm leading-relaxed"
              style={{ color: "rgba(235, 222, 209, 0.7)" }}
            >
              An AI gifting concierge for the people who live far from the ones
              they love. Real reminders, real recommendations, real local
              vendors.
            </p>

            <div className="mt-8 flex items-center gap-3">
              {[Instagram, Twitter, Facebook, Mail].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`footer-social-${i + 1}`}
                  aria-label="Social link placeholder"
                  className="w-10 h-10 rounded-full flex items-center justify-center transition-colors"
                  style={{
                    background: "rgba(251, 247, 241, 0.08)",
                    border: "1px solid rgba(235, 222, 209, 0.18)",
                    color: "var(--liea-cream-soft)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background =
                      "rgba(212, 131, 79, 0.25)";
                    e.currentTarget.style.borderColor =
                      "var(--liea-terracotta)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background =
                      "rgba(251, 247, 241, 0.08)";
                    e.currentTarget.style.borderColor =
                      "rgba(235, 222, 209, 0.18)";
                  }}
                >
                  <Icon size={16} strokeWidth={1.7} />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-8">
            {columns.map((col) => (
              <div key={col.title}>
                <p
                  className="text-xs uppercase tracking-[0.22em] font-medium"
                  style={{ color: "var(--liea-terracotta)" }}
                >
                  {col.title}
                </p>
                <ul className="mt-5 space-y-3">
                  {col.links.map((l) => (
                    <li key={l}>
                      <a
                        href="#"
                        className="text-sm transition-colors"
                        style={{ color: "rgba(235, 222, 209, 0.7)" }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.color =
                            "var(--liea-cream-soft)")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.color =
                            "rgba(235, 222, 209, 0.7)")
                        }
                      >
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div
          className="mt-16 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4"
          style={{ borderTop: "1px solid rgba(235, 222, 209, 0.15)" }}
        >
          <p
            className="text-xs uppercase tracking-[0.32em] font-medium"
            style={{ color: "rgba(235, 222, 209, 0.85)" }}
          >
            Love in every absence
          </p>
          <p
            className="text-xs"
            style={{ color: "rgba(235, 222, 209, 0.5)" }}
          >
            © {new Date().getFullYear()} Liéa. Made with care, across distance.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
